
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import SEOHead from '../../components/base/SEOHead';

const ContactPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <SEOHead 
        title="Contact HP Inc Consulting Services - Get Professional Safety Consulting Quote"
        description="Contact HP Inc Consulting Services for professional safety consulting, OSHA compliance, industrial hygiene, and training services. Serving New York, New Jersey, Pennsylvania, Connecticut, Maryland, and Boston."
        keywords="contact safety consultant, safety consulting quote, OSHA consulting contact, industrial hygiene contact, safety training contact, New York safety consultant, professional safety services contact"
        canonical="https://hpincconsultant.com/contact"
        ogTitle="Contact HP Inc Consulting Services - Professional Safety Consulting"
        ogDescription="Get in touch with our expert safety consultants for comprehensive OSHA compliance and workplace safety solutions."
        ogUrl="https://hpincconsultant.com/contact"
      />
      <Header />
      <main>
        {/* Hero Section */}
        <section className="relative bg-gradient-to-r from-blue-900 to-blue-700 text-white py-20">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto text-center">
              <h1 className="text-4xl md:text-5xl font-bold mb-6">
                Contact Us
              </h1>
              <p className="text-xl mb-8">
                Get in touch for your safety consulting needs
              </p>
            </div>
          </div>
        </section>

        {/* Contact Section */}
        <section className="py-16">
          <div className="container mx-auto px-4">
            <div className="max-w-6xl mx-auto">
              <div className="grid md:grid-cols-2 gap-12">
                <div>
                  <h2 className="text-3xl font-bold mb-6">Get In Touch</h2>
                  <div className="space-y-6">
                    <div className="flex items-start">
                      <i className="ri-phone-line text-2xl text-blue-600 mr-4 mt-1"></i>
                      <div>
                        <h3 className="font-semibold mb-1">Phone</h3>
                        <p className="text-gray-600">(555) 123-4567</p>
                      </div>
                    </div>
                    <div className="flex items-start">
                      <i className="ri-mail-line text-2xl text-blue-600 mr-4 mt-1"></i>
                      <div>
                        <h3 className="font-semibold mb-1">Email</h3>
                        <p className="text-gray-600">info@360safety.com</p>
                      </div>
                    </div>
                    <div className="flex items-start">
                      <i className="ri-map-pin-line text-2xl text-blue-600 mr-4 mt-1"></i>
                      <div>
                        <h3 className="font-semibold mb-1">Address</h3>
                        <p className="text-gray-600">123 Safety Street<br />Business City, ST 12345</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <form className="space-y-6">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Name</label>
                      <input type="text" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus-border-transparent" />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Email</label>
                      <input type="email" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus-border-transparent" />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Message</label>
                      <textarea rows={4} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus-border-transparent"></textarea>
                    </div>
                    <button type="submit" className="w-full bg-blue-600 text-white py-3 px-6 rounded-lg hover:bg-blue-7 transition-colors whitespace-nowrap">
                      Send Message
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default ContactPage;
